import Awards from "@/components/Awards/Awards.component";
import CapabilityProducts from "@/components/CapabilityProducts/CapabilityProducts.component";
import CardLayout from "@/components/CardLayout/CardLayout.component";
import CopyBlock from "@/components/CopyBlock/CopyBlock.component";
import CustomAccordion from "@/components/CustomAccordion/CustomAccordion.component";
import CustomSwiper from "@/components/CustomSwiper/CustomSwiper.component";
import HeroModule from "@/components/HeroModule/HeroModule.component";
import HeroVideoShowcase from "@/components/HeroVideoShowcase/HeroVideoShowcase.component";
import ImageStacked from "@/components/ImageStacked/ImageStacked.component";
import IntroModule from "@/components/IntroModule/IntroModule.component";
import { Leadership } from "@/components/Leadership/Leadership.component";
import LogoList from "@/components/LogoList/LogoList.component";
import { PullQuote } from "@/components/PullQuote/PullQuote.component";
import Results from "@/components/Results/Results.component";
import TextOverAsset from "@/components/TextOverAsset/TextOverAsset.component";
import TypeAndImage from "@/components/TypeAndImage/TypeAndImage.component";
import VideoModule from "@/components/VideoModule/VideoModule.component";

export const componentMapping = Object.freeze({
  ComponentAccordion: CustomAccordion,
  ComponentAwards: Awards,
  ComponentCapabilityProducts: CapabilityProducts,
  ComponentCapabilityServices: CustomSwiper,
  ComponentImageStacked: ImageStacked,
  ComponentOurTeam: Leadership,
  ComponentPartnerList: LogoList,
  ComponentPeopleProfileGroup: CustomSwiper,
  ComponentResults: Results,
  ComponentSeeMoreCapabilities: CustomSwiper,
  ComponentSliderCardGroup: CustomSwiper,
  ComponentTextOverAsset: TextOverAsset,
  CopyBlock: CopyBlock,
  FeaturedCaseStudies: CardLayout,
  HeroModule: HeroModule,
  HeroVideoShowcase: HeroVideoShowcase,
  IntroductionModule: IntroModule,
  PullQuote: PullQuote,
  TypeAndImage: TypeAndImage,
  VideoModule: VideoModule,
});
